import { useOutletContext } from 'react-router-dom';

import { LegalAgreementHtmlBlock } from '../widget-ui/legal-agreement-html-block';
import { formatISODate } from '../widget-lib/format-date';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import type { LegalDocumentsOutletContext } from './legal_LegalDocumentsOutlet';

export default function LegalPrivacyPage() {
  useWidgetSeo(
    'Политика конфиденциальности',
    'Согласие на обработку персональных данных и политика конфиденциальности.'
  );
  const { data } = useOutletContext<LegalDocumentsOutletContext>();
  return (
    <article className="space-y-4 w-full min-w-0 px-4 py-4">
      <h1 className="text-xl font-semibold tracking-tight">Политика конфиденциальности</h1>
      {data.PersonalDataProcessingDate && (
        <p className="text-xs text-[var(--text-muted)]">от {formatISODate(data.PersonalDataProcessingDate)}</p>
      )}
      <LegalAgreementHtmlBlock html={data.PersonalDataProcessingText} />
    </article>
  );
}
